import script from "./configForm.vue?vue&type=script&setup=true&lang=ts"
export * from "./configForm.vue?vue&type=script&setup=true&lang=ts"

import "./configForm.vue?vue&type=style&index=0&id=1d2f79da&lang=less&scoped=true"

import exportComponent from "/opt/teams-app/node_modules/.pnpm/vue-loader@17.0.0_webpack@5.74.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1d2f79da"]])

export default __exports__